import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { playPause, updateColor } from '../../../redux/slices/visualSlice';

const BucketSort = ({ countIterations }) => {
  const myState = useSelector(state => state.updateProps);
  const dispatch = useDispatch();
  const timeoutsRef = useRef([]);
  const cancelledRef = useRef(false);

  const clearAllTimeouts = () => {
    cancelledRef.current = true;
    timeoutsRef.current.forEach(clearTimeout);
    timeoutsRef.current = [];
  };

  const schedule = (fn, delay) => {
    if (cancelledRef.current) return;
    const id = setTimeout(() => {
      if (!cancelledRef.current) fn();
    }, delay);
    timeoutsRef.current.push(id);
  };

  const solve = () => {
    const values = myState.values.map(item => item[0]);
    const ids = myState.values.map(item => item[1]);
    const speed = myState.speed;
    const color = myState.color;
    const slowMultiplier = 3;
    const currentSpeed = speed * slowMultiplier;

    const numBuckets = Math.max(1, Math.floor(Math.sqrt(values.length)));
    const minValue = Math.min(...values);
    const maxValue = Math.max(...values);
    const range = maxValue === minValue ? 1 : (maxValue - minValue) / numBuckets;

    const buckets = Array.from({ length: numBuckets }, () => []);
    values.forEach((value, index) => {
      let bi = Math.floor((value - minValue) / range);
      if (bi >= numBuckets) bi = numBuckets - 1;
      buckets[bi].push([value, ids[index]]);
    });

    let sortedArray = [];
    buckets.forEach(bucket => {
      bucket.sort((a, b) => a[0] - b[0]);
      sortedArray = sortedArray.concat(bucket);
    });

    let timer = 0;
    sortedArray.forEach(([, id], index) => {
      schedule(() => {
        const originalIndex = ids.indexOf(id);
        const currentElement = document.getElementById(id);
        const targetElement  = document.getElementById(ids[index]);

        currentElement.style.transform = `translateX(${index * 11}px)`;
        targetElement.style.transform  = `translateX(${originalIndex * 11}px)`;

        currentElement.childNodes[1].style.backgroundColor = 'black';
        targetElement.childNodes[1].style.backgroundColor  = 'black';

        schedule(() => {
          currentElement.childNodes[1].style.backgroundColor = color;
          targetElement.childNodes[1].style.backgroundColor  = color;
        }, currentSpeed - 10);

        [ids[originalIndex], ids[index]]       = [ids[index], ids[originalIndex]];
        [values[originalIndex], values[index]] = [values[index], values[originalIndex]];

        countIterations(index);
      }, timer * currentSpeed);
      timer++;
    });

    schedule(() => {
      dispatch(playPause(false));
      dispatch(updateColor('rgb(0, 182, 0)'));
    }, timer * currentSpeed + 50);
  };

  useEffect(() => {
    if (myState.algorithm === 'bucket' && myState.play) {
      clearAllTimeouts();
      cancelledRef.current = false;
      solve();
    }
    return clearAllTimeouts;
  }, [myState.play]);

  useEffect(() => {
    return clearAllTimeouts;
  }, [myState.algorithm, myState.values]);

  return <></>;
};

export default BucketSort;
